// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".header-brand {\n  display: flex;\n  align-items: center;\n  text-decoration: none;\n  padding: 0;\n}\n\n.header-brand img {\n  height: 26px;\n  padding-right: 15px;\n  padding-left: 15px;\n  position: relative;\n  top: -1px;\n}\n", ""]);
// Exports
module.exports = exports;
